module.exports = __webpack_public_path__ + "img/wap-cyt.d0272192.png";